import ComingSoon from "./ComingSoon";

function Contact() {
    return (
      <div>
        <ComingSoon />
      </div>
    );
  }
  
  export default Contact;
  